/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
export type ISearchCarrierApplicationFragment = { __typename?: 'CarrierApplication' } & Pick<
  Types.ICarrierApplication,
  'id' | 'name'
>

export const SearchCarrierApplicationFragmentDoc = gql`
  fragment SearchCarrierApplication on CarrierApplication {
    id
    name
  }
`
